
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class HazardListItem extends Vue {
  @Prop({})
  hazardItem: any;
  public show = true;
  @Prop({})
  index!: number;
  @Prop()
  onScreen!: boolean;
  @Prop()
  customersRetrieved!: boolean;
  @Prop()
  retrievingCustomerData!: boolean;

  public getDirectives(
    displayName: string,
    onScreen: boolean
  ): Record<string, string>[] {
    return onScreen ? Vue.prototype.directives[displayName] : [];
  }

  public hasDirectives(displayName: string): boolean {
    return (
      displayName in Vue.prototype.directives &&
      Vue.prototype.directives[displayName].length > 0
    );
  }

  public dynamicClasses(status: string, index: number) {
    return {
      "has-background-danger-light": status == "danger",
      "mt-2": index == 0
    };
  }

  private borderColors(status: string) {
    const lightDark = ["no-fire-danger"].includes(status);
    return {
      "border-top-white": lightDark,
      "border-top-grey": !lightDark
    };
  }

  public hazardActionIcon(item: Record<string, any>, show: boolean): string[] {
    const type: string = item.hazardType;
    const status: string = item.displayStatus;
    const customerIcons: string[] = item.customerIcons;
    const icons: string[] = [];
    if (type == "significant roadside vegetation data") icons.push("fa-user");
    if (["access track", "surrounding track"].includes(type))
      icons.push("fa-road");
    if (type == "access point") {
      if (status == "success") icons.push("fa-unlock");
      else if (status == "danger") icons.push("fa-lock color-red");
      else icons.push("fa-lock color-orange");
    }
    if (type == "fire ban district") {
      let icon = "fa-fire-alt ";
      if (show) {
        icons.push("color-white");
      } else {
        const color: Record<string, string> = {
          catastrophic: "color-catastrophic",
          extreme: "color-extreme",
          severe: "color-severe",
          "very-high": "color-very-high",
          high: "color-high",
          "low-moderate": "color-low-moderate",
          "no-fire-danger": "color-no-fire-danger"
        };
        icon += color[status] || "color-no-fire-danger";
        icons.push(icon);
      }
    }
    if (type == "contaminated site") icons.push("fa-exclamation-triangle");
    if (type == "bio-security") icons.push("fa-biohazard color-red");
    if (type == "declared weed") icons.push("fa-biohazard color-red");
    if (type == "bush for life") icons.push("fa-tree color-green");
    // if (type == "covid-19 cases") icons.push("fa-virus color-red");
    if (type == "cfs incident") icons.push("fa-burn color-red");
    if (type == "ses_incident") icons.push("fa-exclamation-circle color-red");
    if (type == "bom error") icons.push("fa-exclamation-triangle color-orange");
    if (type == "bom no alerts") icons.push("fa-sun");
    if (type == "weather warning")
      icons.push("fa-exclamation-triangle color-red");
    if (type == "bom placeholder") icons.push("fa-spinner fa-spin color-blue");
    if (type == "defibrillators") icons.push("fa-aed");
    if (customerIcons != undefined) {
      if (type == "customer data" && customerIcons.length == 0)
        icons.push("fa-user");
      if (customerIcons.includes("danger-customer"))
        icons.push("fa-user color-red");
      if (customerIcons.includes("danger-dogs")) icons.push("fa-dog color-red");
      if (customerIcons.includes("life-support"))
        icons.push("fa-hand-holding-medical color-red");
      if (customerIcons.includes("electric-hazard"))
        icons.push("fa-bolt color-red");
      if (customerIcons.includes("general-hazard"))
        icons.push("fa-exclamation-triangle color-orange");
      if (customerIcons.includes("meterbox-hazard"))
        icons.push("fa-tachometer-alt color-red");
      if (customerIcons.includes("bio-hazard"))
        icons.push("fa-biohazard color-red");
    }
    if (icons.length == 0) {
      icons.push("fa-question-circle");
    }
    return icons;
  }

  mounted() {
    this.show = this.onScreen
      ? this.hazardItem.count == 1 &&
        this.hazardItem.hazardType != "weather warning"
      : true;
  }

  public fireDangerLevel(hazard: any): string {
    let icon = "fa-fire-alt ";
    const color: Record<string, string> = {
      Catastrophic: "color-catastrophic",
      Extreme: "color-extreme",
      Severe: "color-severe",
      "Very High": "color-very-high",
      High: "color-high",
      "Low-Moderate": "color-low-moderate",
      "No Fire Danger Rating": "color-no-fire-danger"
    };
    icon += color[hazard.fireDangerRating] || "color-no-fire-danger";
    return icon;
  }

  public retrieveCustomers() {
    this.$emit("retrieve-customers");
  }
}
